import React, { useState, useEffect } from "react";

import { ReactComponent as ChangeLanguageLogo } from "../logos/language_change.svg";

import "./styles/logos.css";
import "./styles/language.css";
const LanguageChange = ({ i18n }) => {
  const [language, setLanguage] = useState("en");

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);
  const changeLang = () => {
    if (language === "en") {
      setLanguage("he");
    } else if (language === "he") {
      setLanguage("en");
    }
  };
  return (
    <div className="language-container">
      <div
        style={{ marginTop: "1em", marginRight: "1em" }}
        onClick={changeLang}
      >
        <ChangeLanguageLogo className="lang-logo" />
      </div>
    </div>
  );
};

export default LanguageChange;
